var _excluded = ["theme", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { ThemeProvider as MuiThemeProvider, createMuiTheme, StylesProvider, jssPreset } from '@material-ui/core/styles';
import { create } from 'jss';
import StyledEngineProvider from '@material-ui/core/StyledEngineProvider';
import CssBaseline from '@material-ui/core/CssBaseline';
import { theme as defaultTheme } from '../../theme';
var jss = create({
  plugins: [].concat(jssPreset().plugins)
});

/**
 *  Material UI and Styled Components combined theme provider
 *
 * @see https://material-ui.com/customization/default-theme/
 */
function ThemeProvider(_ref) {
  var theme = _ref.theme,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var mergedTheme = createMuiTheme(theme);
  return /*#__PURE__*/React.createElement(StyledEngineProvider, {
    injectFirst: true
  }, /*#__PURE__*/React.createElement(StylesProvider, {
    jss: jss
  }, /*#__PURE__*/React.createElement(StyledThemeProvider, {
    theme: mergedTheme
  }, /*#__PURE__*/React.createElement(MuiThemeProvider, _extends({
    theme: mergedTheme
  }, rest), /*#__PURE__*/React.createElement(CssBaseline, null), children))));
}
ThemeProvider.propTypes = process.env.NODE_ENV !== "production" ? {
  theme: PropTypes.shape({
    breakpoints: PropTypes.object,
    mixins: PropTypes.object,
    overrides: PropTypes.object,
    palette: PropTypes.object,
    props: PropTypes.object,
    shadows: PropTypes.array,
    typography: PropTypes.object,
    spacing: PropTypes.func,
    shape: PropTypes.object,
    transitions: PropTypes.object,
    zIndex: PropTypes.object
  }),
  children: PropTypes.any.isRequired
} : {};
ThemeProvider.defaultProps = {
  theme: defaultTheme
};
export default ThemeProvider;